// @flow

import queryString from 'query-string';
import pick from 'lodash/pick';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { cookies as COOKIES_CONFIG } from 'Config';
import { Cookies } from 'shared_services/riseart/utils/Cookies/Cookies';
import { useUrlParams } from 'shared_data/providers/url/useUrlParams';

import { selectMarketingCampaignId } from 'shared_services/redux/selectors/marketing';

export type AuthParamsType = {
  forward?: string,
  quizResponseId?: string | number,
  marketingCampaignId?: string | number,
  referrerId?: string,
};

/**
 * useAuthParams
 *
 * @param {Object} pickedParams
 * @returns AuthParamsType
 */
export function useAuthParams(pickedParams?: Object): AuthParamsType {
  const marketingCampaignId = useSelector(selectMarketingCampaignId);
  const referrerId = Cookies.get(COOKIES_CONFIG.referrerSession.name) || null;
  const { translatedLocation: location } = useUrlParams() || {};
  const { search } = location || {};
  const selectedQsParams = useMemo(() => {
    const qsParams = queryString.parse(search);
    return pickedParams ? pick(qsParams, pickedParams) : qsParams;
  }, [search, pickedParams]);

  return {
    ...selectedQsParams,
    ...(marketingCampaignId ? { marketingCampaignId: parseInt(marketingCampaignId, 10) } : null),
    ...(referrerId ? { referrerId: parseInt(referrerId, 10) } : null),
  };
}
